import { motion } from 'framer-motion';
import { Globe, Building, Users, Zap } from 'lucide-react';
import Section from '../components/Section';
import Button from '../components/Button';
import PageHero from '../components/PageHero';
import { SF_UI } from '../components/ui/tokens';

const BaasPage = () => {
  return (
    <>
      <PageHero
        eyebrow="Community · B.A.A.S."
        title="B.A.A.S."
        subtitle={
          <>
            <span className="block text-primary-200 font-medium mb-2">
              Blockchains Apertum Avalanche Sportsworld
            </span>
            <span className="italic text-slate-300">
              Redefining &quot;Banking as a Service&quot; for the Sports World
            </span>
          </>
        }
      />
      <Section bgColor={SF_UI.sectionBand} className="pt-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-5xl mx-auto"
      >
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-white rounded-2xl shadow-lg sf-surface-card sf-ui-system p-8 md:p-12 mb-12"
        >
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-6">
              Blockchains Apertum Avalanche Sportsworld (B.A.A.S.) is a groundbreaking decentralized platform that redefines "Banking as a Service" by putting you in charge. Rooted in the Dutch and South African meaning of "baas" – a boss or master – B.A.A.S. leverages blockchain technology to give users unparalleled control and mastery over their interactions in the sports world.
            </p>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              We're further expanding this vision by introducing SportOffices in every country, state, and region worldwide, creating a truly global and accessible network for all sports enthusiasts in web 3.0 environment.
            </p>
            
            <p className="text-gray-700 leading-relaxed">
              Building on this, we're also launching Houses of Sports, enabling every club, organization, and athlete to establish their own unique Web3.0 presence and create a true home within this decentralized sports world.
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="bg-white p-6 rounded-2xl shadow-md sf-surface-card sf-ui-system border-l-4 border-primary"
          >
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center text-primary">
                <Zap size={32} />
              </div>
            </div>
            <h3 className="text-xl font-semibold text-center mb-3">Decentralized Control</h3>
            <p className="text-gray-600 text-center">
              Take complete control of your sports world interactions with blockchain-powered autonomy and transparency.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="bg-white p-6 rounded-2xl shadow-md sf-surface-card sf-ui-system border-l-4 border-secondary"
          >
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-secondary-100 rounded-full flex items-center justify-center text-secondary">
                <Globe size={32} />
              </div>
            </div>
            <h3 className="text-xl font-semibold text-center mb-3">Global SportOffices</h3>
            <p className="text-gray-600 text-center">
              Access a worldwide network of SportOffices in every country, state, and region for comprehensive support.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="bg-white p-6 rounded-2xl shadow-md sf-surface-card sf-ui-system border-l-4 border-primary"
          >
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center text-primary">
                <Building size={32} />
              </div>
            </div>
            <h3 className="text-xl font-semibold text-center mb-3">Houses of Sports</h3>
            <p className="text-gray-600 text-center">
              Establish your unique Web3.0 presence and create a true home in the decentralized sports ecosystem.
            </p>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="bg-gradient-to-br from-primary-50 to-secondary-50 rounded-lg p-8 text-center"
        >
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center">
              <Users size={40} className="text-white" />
            </div>
          </div>
          <h2 className="text-2xl font-bold mb-4">Join the B.A.A.S. Revolution</h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
            Be part of the future of sports technology. Experience true ownership and control in the Web3.0 sports ecosystem.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button to="/apply" variant="primary" size="lg">
              Get Started
            </Button>
            <Button to="/contact" variant="secondary" size="lg">
              Learn More
            </Button>
          </div>
        </motion.div>
      </motion.div>
      </Section>
    </>
  );
};

export default BaasPage;